<template>
	<v-container class="half pa-0">
		<ValidationError :errors="errors" />

		<v-form ref="form">
			<v-stepper v-model="stepNumber" elevation="0">
				<v-stepper-header class="elevation-0">
					<v-stepper-step :complete="stepNumber > 1" step="1"> 基本情報 </v-stepper-step>
					<v-divider></v-divider>
					<v-stepper-step :complete="stepNumber > 2" step="2"> 顧客情報 </v-stepper-step>
					<v-divider></v-divider>
					<v-stepper-step :complete="stepNumber > 3" step="3"> 金額情報 </v-stepper-step>
					<v-divider></v-divider>
					<v-stepper-step :complete="stepNumber > 4" step="4"> 時期情報 </v-stepper-step>
					<v-divider></v-divider>
					<v-stepper-step :complete="stepNumber > 5" step="5"> 詳細情報 </v-stepper-step>
					<v-divider v-if="matter.basic.contract"></v-divider>
					<v-stepper-step v-if="matter.basic.contract" :complete="stepNumber > 6" step="6">
						納入先情報
					</v-stepper-step>
				</v-stepper-header>

				<v-stepper-items>
					<v-stepper-content step="1" class="pa-0">
						<v-card class="ma-2 pa-0" elevation="4">
							<v-app-bar dense dark flat color="primary">
								<v-app-bar-title class="color-white"> 案件基本情報 </v-app-bar-title>
								<v-spacer />
							</v-app-bar>
							<!-- 基本情報項目(Matterテーブル) -->
							<keep-alive>
								<MatterBasicForm
									v-if="stepNumber === 1"
									:basic.sync="matter.basic"
									:categories="categories"
									:teams="teams"
									:situations="situations"
									:subCategories="subCategories"
									:teamUsers="teamUsers"
								/>
							</keep-alive>
							<v-row no-gutters class="my-4 pb-4" justify="center">
								<v-btn color="secondary" :disabled="!isValid" @click="renderPage(2)">
									<v-icon class="mr-2">mdi-page-next</v-icon>
									決定して次へ進む</v-btn
								>
							</v-row>
						</v-card>
					</v-stepper-content>

					<v-stepper-content step="2" class="pa-0">
						<v-card class="ma-2 pa-0" elevation="4">
							<v-app-bar dense dark flat color="primary">
								<v-app-bar-title class="color-white"> 案件顧客情報 </v-app-bar-title>
								<v-spacer />
								<v-btn @click="renderPage(1)" text color="white">
									<v-icon class="mr-2">mdi-arrow-left-circle</v-icon>
									基本情報へ戻る</v-btn
								>
							</v-app-bar>
							<!-- 顧客情報項目(Matterテーブル) -->
							<keep-alive>
								<MatterClientForm
									v-if="stepNumber === 2"
									:client.sync="matter.client"
									:editRegularCustomerPersons="editRegularCustomerPersons"
									:editCustomerPersons="editCustomerPersons"
									:distributionChannels="distributionChannels"
									:current_company_name="current_company_name"
									:teamUsers="teamUsers"
								/>
							</keep-alive>
							<v-row no-gutters class="my-4 pb-4" justify="center">
								<v-btn color="secondary" @click="renderPage(3)">
									<v-icon class="mr-2">mdi-page-next</v-icon>
									決定して次へ進む</v-btn
								>
							</v-row>
						</v-card>
					</v-stepper-content>

					<v-stepper-content step="3" class="pa-0">
						<v-card class="ma-2 pa-0" elevation="4">
							<v-app-bar dense dark flat color="primary">
								<v-app-bar-title class="color-white"> 案件金額情報 </v-app-bar-title>
								<v-spacer />
								<v-btn @click="renderPage(2)" text color="white">
									<v-icon class="mr-2">mdi-arrow-left-circle</v-icon>
									顧客情報へ戻る</v-btn
								>
							</v-app-bar>
							<!-- 金額情報項目 -->
							<keep-alive>
								<MatterMoneyForm
									v-if="stepNumber === 3"
									:money.sync="matter.money"
									:matter_products="matter_products"
									:contract="matter.basic.contract"
								/>
							</keep-alive>
							<v-row no-gutters class="my-4 pb-4" justify="center">
								<v-btn color="secondary" @click="renderPage(4)">
									<v-icon class="mr-2">mdi-page-next</v-icon>
									決定して次へ進む</v-btn
								>
							</v-row>
						</v-card>
					</v-stepper-content>

					<v-stepper-content step="4" class="pa-0">
						<v-card class="ma-2 pa-0" elevation="4">
							<v-app-bar dense dark flat color="primary">
								<v-app-bar-title class="color-white"> 案件時期情報 </v-app-bar-title>
								<v-spacer />
								<v-btn @click="renderPage(3)" text color="white">
									<v-icon class="mr-2">mdi-arrow-left-circle</v-icon>
									金額情報へ戻る</v-btn
								>
							</v-app-bar>
							<!--時期情報項目 -->

							<keep-alive>
								<MatterQuotationForm
									v-if="stepNumber === 4"
									:quotation="matter.quotation"
									:company_periods="company_periods"
									:contract="matter.basic.contract"
								/>
							</keep-alive>
							<v-row no-gutters class="my-4 pb-4" justify="center">
								<v-btn color="secondary" @click="renderPage(5)">
									<v-icon class="mr-2">mdi-page-next</v-icon>
									決定して次へ進む</v-btn
								>
							</v-row>
						</v-card>
					</v-stepper-content>

					<v-stepper-content step="5" class="pa-0">
						<v-card class="ma-2 pa-0" elevation="4">
							<v-app-bar dense dark flat color="primary">
								<v-app-bar-title class="color-white"> 案件詳細情報 </v-app-bar-title>
								<v-spacer />
								<v-btn @click="renderPage(4)" text color="white">
									<v-icon class="mr-2">mdi-arrow-left-circle</v-icon>
									時期情報へ戻る</v-btn
								>
							</v-app-bar>
							<!--詳細項目(MatterValueテーブル) -->
							<keep-alive>
								<MatterDetailForm
									v-if="stepNumber === 5"
									:matter_values="matter_values"
									:detail="matter.detail"
									:contract="matter.basic.contract"
								/>
							</keep-alive>
							<v-row v-if="matter.basic.contract" no-gutters class="my-4 pb-4" justify="center">
								<v-btn color="secondary" @click="renderPage(6)">
									<v-icon class="mr-2">mdi-page-next</v-icon>
									決定して次へ進む</v-btn
								>
							</v-row>
							<v-row v-else class="my-4 pb-4" justify="center">
								<v-btn
									class="ma-1 white--text font-weight-bold"
									@click.prevent="updateMatter"
									:disabled="!isValid"
									dense
									color="secondary"
									>更新する</v-btn
								>
							</v-row>
						</v-card>
					</v-stepper-content>

					<v-stepper-content step="6" class="pa-0">
						<v-card class="ma-2 pa-0" elevation="4">
							<v-app-bar dense dark flat color="primary">
								<v-app-bar-title class="color-white"> 案件納入先情報 </v-app-bar-title>
								<v-spacer />
								<v-btn @click="renderPage(5)" text color="white">
									<v-icon class="mr-2">mdi-arrow-left-circle</v-icon>
									詳細情報へ戻る</v-btn
								>
							</v-app-bar>
							<!-- 納入先情報項目 -->
							<keep-alive>
								<MatterDeliveryForm
									v-if="stepNumber === 6"
									:delivery.sync="matter.delivery"
									@delivery_form_valid="delivery_form_valid = $event"
								/>
							</keep-alive>
							<v-row class="my-4 pb-4" justify="center">
								<v-btn
									class="ma-1 white--text font-weight-bold"
									@click.prevent="updateMatter"
									:disabled="!isValid || !delivery_form_valid"
									dense
									color="secondary"
									>更新する</v-btn
								>
							</v-row>
						</v-card>
					</v-stepper-content>
				</v-stepper-items>
			</v-stepper>
		</v-form>
	</v-container>
</template>

<script>
import axios from "axios"
import rules from "../../helper/rules"
import authenticate from "../../helper/authenticate"
import errorHandling from "../../helper/errorHandling"
import ValidationError from "../shared/ValidationError.vue"
import MatterBasicForm from "./components/MatterBasicForm.vue"
import MatterClientForm from "./components/MatterClientForm.vue"
import MatterMoneyForm from "./components/MatterMoneyForm.vue"
import MatterQuotationForm from "./components/MatterQuotationForm.vue"
import MatterDetailForm from "./components/MatterDetailForm.vue"
import MatterDeliveryForm from "./components/MatterDeliveryForm.vue"

export default {
	components: {
		ValidationError,
		MatterBasicForm,
		MatterClientForm,
		MatterMoneyForm,
		MatterQuotationForm,
		MatterDetailForm,
		MatterDeliveryForm,
	},
	data() {
		return {
			mainTitle: "案件編集ページ",
			pageTitle: "案件情報編集",
			MatterFileIndexDialogFlag: false,
			id: this.$route.params.id,
			rules,
			stepNumber: 1,
			matter: {
				basic: {
					name: "",
					productCategory: "",
					productSubCategory: "",
					situation: "",
					team: "",
					teamMember: "",
					contract: "",
					regularlySold: "",
					description: "",
					points: "",
					changeContract: false,
				},
				client: {
					regularCustomer: "",
					regularCustomerPerson: "",
					endUser: "",
					customerPerson: "",
					plantCompany: "",
				},
				money: {
					totalCost: "",
					quotationAmount: "",
					product: "",
					orderedAmount: "",
					lostAmount: "",
				},
				quotation: {
					quotationDeadline: "",
					deadline: "",
					quotationSubmissionDate: "",
					plannedOrderDate: "",
					companyPeriod: "",
					costingRequestDate: "",
					costReceiptDate: "",
					deadline: "",
					orderDate: "",
				},
				detail: {
					competitor: "",
					lostTo: "",
					lostReason: "",
				},
				delivery: {
					zipcode: "",
					address: "",
					phone: "",
					fax: "",
					company: "",
					person: "",
					city: "",
					prefecture: "",
				},
			},
			subCategories: [],
			customerPersons: [],
			distributionChannels: [],
			errors: [],
			teams: [],
			categories: [],
			current_company_name: "",
			company_periods: [],
			matter_values: [],
			matter_products: [],
			products: [],
			situations: [],
			delivery_form_valid: false,
			teamUsers: [],
			initMatterProducts: [],
			initMatterValues: [],
			editRegularCustomerPersons: [],
			editCustomerPersons: [],
			editPersons: [],
		}
	},
	mounted() {
		this.fetchMatter()
	},
	methods: {
		renderPage(num) {
			this.stepNumber = num
			window.scrollTo({
				top: 0,
				behavior: "smooth",
			})
		},
		fetchMatter() {
			const headers = authenticate.setHeader()
			axios
				.get(`/erp/v1/matters/${this.id}/edit`, { headers })
				.then((res) => {
					this.setMatter(res.data)
					this.teams = res.data.teams
					this.categories = res.data.categories
					// this.customer_companies = res.data.customer_companies
					this.current_company_name = res.data.current_company_name
					this.company_periods = res.data.company_periods
					this.situations = res.data.situations
					this.products = res.data.matter.products
					this.initMatterProducts = res.data.matter.matter_products
					this.setMatterProducts(res.data.matter.matter_products)
					this.initMatterValues = res.data.matter.matter_values
					this.setMatterValue(res.data.matter.matter_values)
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
		setMatterValue(initMatterValues) {
			initMatterValues.forEach((matter_value) => {
				const obj = {
					matter_key: {
						...matter_value.matter_key,
					},
					matter_value: {
						id: matter_value.id,
						matter_key_id: matter_value.matter_key.id,
						value: matter_value.value,
					},
				}
				this.matter_values.push(obj)
			})
		},
		setMatterProducts(init_matter_products) {
			init_matter_products.forEach((matter_product) => {
				let obj = {
					id: matter_product.product.id,
					name: matter_product.product.name,
					cost_price: matter_product.product.cost_price,
					standard_price: matter_product.product.standard_price,
					list_price: matter_product.product.list_price,
					product_category: {
						name: matter_product.product.product_category.name,
					},
					product_unit_price: matter_product.unit_price,
					product_quantity: matter_product.quantity,
					product_sub_name: matter_product.sub_name,
				}
				this.matter_products.push(obj)
			})
		},
		setMatter(res) {
			// basic
			this.matter.basic.name = res.matter.name
			this.matter.basic.productCategory = res.matter.product_category_id
			this.matter.basic.productSubCategory = res.matter.product_sub_category_id
			this.matter.basic.team = res.matter.team_id
			this.setSubCategories(this.matter.basic.productCategory, res.categories)
			this.setTeamMembers(this.matter.basic.team, res.teams)
			this.matter.basic.situation = res.matter.situation
			this.matter.basic.contract = res.matter.contract
			this.matter.basic.regularlySold = res.matter.regularly_sold
			this.matter.basic.description = res.matter.description
			this.matter.basic.points = res.matter.points

			// client
			if (res.matter.regular_customer_company) {
				this.matter.client.regularCustomer = res.matter.regular_customer_company
				this.editRegularCustomerPersons = res.matter.regular_customer_company.customer_people
				this.matter.client.regularCustomerPerson = Number(res.matter.regular_customer_person_id)
			}
			if (res.matter.customer_company) {
				this.matter.client.endUser = res.matter.customer_company
				this.editCustomerPersons = res.matter.customer_company.customer_people
				this.matter.client.customerPerson = Number(res.matter.customer_person_id)
			}
			if (res.matter.plant_customer_company) {
				this.matter.client.plantCompany = res.matter.plant_customer_company.name
			}
			if (
				res.matter.distribution_channel &&
				res.matter.distribution_channel.customer_companies.length
			) {
				this.setDistributionChannel(res.matter.distribution_channel.customer_companies)
			}

			// money
			this.matter.money.orderedAmount = res.matter.ordered_amount
			this.matter.money.lostAmount = res.matter.lost_amount
			this.matter.money.totalCost = res.matter.total_cost
			this.matter.money.quotationAmount = res.matter.quotation_amount

			// quotation
			this.matter.quotation.quotationDeadline = res.matter.quotation_deadline
			this.matter.quotation.quotationSubmissionDate = res.matter.quotation_submission_date
			this.matter.quotation.deadline = res.matter.deadline
			this.matter.quotation.plannedOrderDate = res.matter.planned_order_date
			this.matter.quotation.companyPeriod = res.matter.company_period_id
			this.matter.quotation.orderDate = res.matter.order_date
			this.matter.quotation.costingRequestDate = res.matter.costing_request_date
			this.matter.quotation.costReceiptDate = res.matter.cost_receipt_date
			this.matter.quotation.quotationDeadline = res.matter.quotation_deadline

			// detail
			this.matter.detail.competitor = res.matter.competitor
			this.matter.detail.lostTo = res.matter.lost_to
			this.matter.detail.lostReason = res.matter.lost_reason

			// delivery
			this.matter.delivery.zipcode = res.matter.delivery_zipcode
			this.matter.delivery.prefecture = res.matter.delivery_prefecture
			this.matter.delivery.city = res.matter.delivery_city
			this.matter.delivery.address = res.matter.delivery_address
			this.matter.delivery.phone = res.matter.delivery_phone
			this.matter.delivery.fax = res.matter.delivery_fax
			this.matter.delivery.company = res.matter.delivery_company_name
			this.matter.delivery.person = res.matter.delivery_person_name
		},
		setDistributionChannel(customer_companies) {
			customer_companies.forEach((customer_company) => {
				let obj = new Object()
				obj.value = customer_company
				this.distributionChannels.push(obj)
			})
		},
		setTeamMembers(team_id, teams) {
			teams.forEach((team) => {
				if (team.id == team_id) {
					this.teamUsers = team.users
					team.team_members.forEach((team_member) => {
						team_id == team_member.team_id
						this.matter.basic.teamMember = team_member.user_id
					})
				}
			})

			// フルネームの作成
			this.teamUsers.forEach((user) => {
				const full_name = user["last_name"] + user["first_name"]
				user["full_name"] = full_name
			})
		},
		setSubCategories(product_category_id, categories) {
			const category = categories.find((category) => category.id == product_category_id)
			if (category) {
				this.subCategories = category.product_sub_categories
			}
		},
		isPresence(value) {
			return value !== null && value !== ""
		},
		updateMatter() {
			let formData = new FormData()

			// matter
			formData.set("matter[name]", this.matter.basic.name)
			formData.set("matter[product_category_id]", this.matter.basic.productCategory)
			formData.set("matter[product_sub_category_id]", this.matter.basic.productSubCategory)
			if (this.matter.basic.team) {
				formData.set("matter[team_id]", this.matter.basic.team)
			}
			if (this.matter.basic.teamMember) {
				formData.set("matter[team_member_id]", this.matter.basic.teamMember)
			}
			if (this.matter.basic.situation) {
				formData.set("matter[situation]", this.matter.basic.situation)
			}
			if (this.matter.basic.contract !== "") {
				formData.set("matter[contract]", this.matter.basic.contract)
			}
			if (typeof this.matter.basic.regularlySold === "boolean") {
				formData.set("matter[regularly_sold]", this.matter.basic.regularlySold)
			}
			if (this.matter.basic.description) {
				formData.set("matter[description]", this.matter.basic.description)
			}
			if (this.matter.basic.points) {
				formData.set("matter[points]", this.matter.basic.points)
			}

			formData.set("matter[change_contract]", this.matter.basic.changeContract)

			if (this.matter.client.regularCustomer) {
				formData.set("matter[regular_customer_id]", this.matter.client.regularCustomer.id)
			}
			if (this.matter.client.regularCustomerPerson) {
				formData.set("matter[regular_customer_person_id]", this.matter.client.regularCustomerPerson)
			}
			if (this.matter.client.endUser) {
				formData.set("matter[customer_company_id]", this.matter.client.endUser.id)
			}
			if (this.matter.client.customerPerson) {
				formData.set("matter[customer_person_id]", this.matter.client.customerPerson)
			}

			if (this.matter.client.plantCompany) {
				formData.set("matter[plant_company_id]", this.matter.client.plantCompany.id)
			}

			if (this.matter.money.totalCost) {
				formData.set("matter[total_cost]", this.matter.money.totalCost)
			}
			if (this.matter.money.quotationAmount) {
				formData.set("matter[quotation_amount]", this.matter.money.quotationAmount)
			}

			if (this.matter.money.orderedAmount) {
				formData.set("matter[ordered_amount]", this.matter.money.orderedAmount)
			}
			if (this.matter.money.lostAmount) {
				formData.set("matter[lost_amount]", this.matter.money.lostAmount)
			}
			if (this.matter.quotation.orderDate) {
				formData.set("matter[order_date]", this.matter.quotation.orderDate)
			}
			if (this.matter.quotation.quotationDeadline) {
				formData.set("matter[quotation_deadline]", this.matter.quotation.quotationDeadline)
			}
			if (this.matter.quotation.deadline) {
				formData.set("matter[deadline]", this.matter.quotation.deadline)
			}
			if (this.matter.quotation.quotationSubmissionDate) {
				formData.set(
					"matter[quotation_submission_date]",
					this.matter.quotation.quotationSubmissionDate
				)
			}

			if (this.matter.quotation.plannedOrderDate) {
				formData.set("matter[planned_order_date]", this.matter.quotation.plannedOrderDate)
			}
			if (this.matter.quotation.companyPeriod) {
				formData.set("matter[company_period_id]", this.matter.quotation.companyPeriod)
			}

			if (this.matter.quotation.costingRequestDate) {
				formData.set("matter[costing_request_date]", this.matter.quotation.costingRequestDate)
			}
			if (this.matter.quotation.costReceiptDate) {
				formData.set("matter[cost_receipt_date]", this.matter.quotation.costReceiptDate)
			}

			if (this.matter.detail.competitor) {
				formData.set("matter[competitor]", this.matter.detail.competitor)
			}
			if (this.matter.detail.lostTo) {
				formData.set("matter[lost_to]", this.matter.detail.lostTo)
			}
			if (this.matter.detail.lostReason) {
				formData.set("matter[lost_reason]", this.matter.detail.lostReason)
			}

			if (this.matter.delivery.zipcode) {
				formData.set("matter[delivery_zipcode]", this.matter.delivery.zipcode)
			}

			if (this.matter.delivery.address) {
				formData.set("matter[delivery_address]", this.matter.delivery.address)
			}

			if (this.matter.delivery.phone) {
				formData.set("matter[delivery_phone]", this.matter.delivery.phone)
			}

			if (this.matter.delivery.fax) {
				formData.set("matter[delivery_fax]", this.matter.delivery.fax)
			}

			if (this.matter.delivery.name) {
				formData.set("matter[delivery_company_name]", this.matter.delivery.company.name)
			}

			if (this.matter.delivery.person) {
				formData.set("matter[delivery_person_name]", this.matter.delivery.person)
			}

			if (this.matter.delivery.prefecture) {
				formData.set("matter[delivery_prefecture]", this.matter.delivery.prefecture)
			}

			if (this.matter.delivery.city) {
				formData.set("matter[delivery_city]", this.matter.delivery.city)
			}

			//distributionChannel
			this.distributionChannels.forEach((company, index) => {
				if (company.value) {
					formData.append(
						`distribution_channels[customer_company_id_0${index + 1}]`,
						company.value.id
					)
				}
			})

			// matter_value
			let json_matter_values = JSON.stringify(this.matter_values)
			formData.append("matter_values", json_matter_values)

			// matter_product
			if (this.matter_products.length) {
				let json_matter_products = JSON.stringify(this.matter_products)
				formData.append("matter_products", json_matter_products)
			}

			const headers = authenticate.setHeader()
			axios
				.put(`/erp/v1/matters/${this.id}`, formData, { headers })
				.then((res) => {
					// 受注かつ受注内容確認書がなければ作成ページへ
					if (res.data.matter.contract && !res.data.exists_order_confirmation) {
						this.$store.dispatch("setFlash", {
							type: "notice",
							text: "案件を更新しました。受注内容確認書を作成してください。",
						})
						this.$router.push({
							name: "order_confirmation_new",
							params: { matter_id: res.data.matter.id },
						})
					} else {
						this.$store.dispatch("setFlash", {
							type: "notice",
							text: "案件を更新しました。",
						})
						this.$router.push({
							name: "matter_show",
							params: { id: res.data.matter.id },
						})
					}
				})
				.catch((err) => {
					if (err.response?.status == 400) {
						this.errors = err.response.data.errors
					}
					errorHandling.errorResponse(err)
				})
		},
	},
	computed: {
		isValid() {
			if (
				this.isPresence(this.matter.basic.name) &&
				this.isPresence(this.matter.basic.productCategory) &&
				this.isPresence(this.matter.basic.productSubCategory) &&
				this.isPresence(this.matter.basic.situation) &&
				this.isPresence(this.matter.basic.team) &&
				this.isPresence(this.matter.basic.teamMember)
			) {
				return true
			} else {
				return false
			}
		},
	},
}
</script>
